import React from 'react';
import { DeleteButton, EditButton, ShowButton } from '@refinedev/antd';
import { Button, Popconfirm, Space, Tag } from 'antd';
import { ColumnType } from '@/types';
import { PauseCircleOutlined, PlayCircleOutlined } from '@ant-design/icons';

export const getColumns = (
  translate: (key: string) => string,
  refetch: () => void,
  handleActivate: (value: boolean) => void,
  setActivateId: (id: string) => void,
  activateId: string,
  activateLoading: boolean
): ColumnType[] => [
  {
    title: translate('listing-classes.id'),
    dataIndex: 'id',
    key: 'id',
  },
  {
    title: translate('listing-classes.name'),
    dataIndex: 'name',
    key: 'name',
  },
  {
    title: translate('listing-classes.description'),
    dataIndex: 'description',
    key: 'description',
    render: (value) => (value ? `${value?.slice(0, 20)}...` : '-'),
  },
  {
    title: translate('listing-classes.year'),
    dataIndex: 'year_range',
    key: 'year',
  },
  {
    title: translate('listing-classes.is_active'),
    dataIndex: 'is_active',
    key: 'is_active',
    render: (value) =>
      value ? (
        <Tag color="green">{translate('listing-classes.active')}</Tag>
      ) : (
        <Tag color="red">{translate('listing-classes.not-active')}</Tag>
      ),
  },
  {
    title: translate('listing-classes.actions'),
    dataIndex: 'actions',
    key: 'actions',
    render: (_, record) => (
      <Space>
        {record.is_active && (
          <ShowButton recordItemId={record.id} hideText size="small" />
        )}
        {record.is_active && (
          <EditButton recordItemId={record.id} hideText size="small" />
        )}
        <Popconfirm
          placement="right"
          title={
            record.is_active
              ? translate('listing-classes.confirm-deactivate')
              : translate('listing-classes.confirm-activate')
          }
          onConfirm={() => {
            handleActivate(!record.is_active);
          }}
          cancelText={translate('listing-classes.cancel')}
          okText={translate('listing-classes.confirm')}
          okButtonProps={{
            type: 'default',
            className: 'border-red-500 text-red-500',
          }}
        >
          <Button
            size="small"
            loading={record.id === activateId && activateLoading}
            className={record.is_active ? 'border-red-500' : 'border-green-500'}
            onClick={() => setActivateId(record.id)}
            icon={
              record.is_active ? (
                <PauseCircleOutlined className="text-red-500" />
              ) : (
                <PlayCircleOutlined className="text-green-500" />
              )
            }
          />
        </Popconfirm>
        <DeleteButton
          recordItemId={record.id}
          hideText
          size="small"
          resource="class"
          successNotification={{
            message: translate('class-messages.delete.success'),
            type: 'success',
          }}
          errorNotification={{
            message: translate('class-messages.delete.error'),
            type: 'error',
          }}
          onSuccess={() => {
            refetch();
          }}
        />
      </Space>
    ),
  },
];
